import { put } from "./methods";

export const updateItemData = async (appId, modelId, data) => {
  const response = await put(`application/${appId}/item_data/${modelId}`, data);

  return response;
};
